/** Shared admin sidebar breakpoint — keep in sync with $breakpoint-tablet */
export const ADMIN_SIDEBAR_TABLET_MAX = 960

export const toggleAdminSidebar = () => {
  const isTablet = window.matchMedia(
    `(max-width: ${ADMIN_SIDEBAR_TABLET_MAX}px)`,
  ).matches

  if (isTablet) {
    document.body.classList.toggle("admin-sidebar-open")
  } else {
    document.body.classList.toggle("admin-sidebar-collapsed")
  }
}
